import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import ROUTES from 'constants/ROUTES';
import { Dropdown } from '.';

const Navbar = styled.nav`
  background-color: transparent;

  .navbar-item:hover {
    color: white !important;
  }
`;

export default function DevelopmentNav() {
  return (
    <Navbar
      className="navbar is-fixed-top is-transparent"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="navbar-menu">
        <div className="navbar-end">
          <NavLink
            className="navbar-item"
            activeClassName="is-active"
            exact
            to={ROUTES.GAME.ROOT}
          >
            Game
          </NavLink>

          <Dropdown
            target={<a className="navbar-link">Acts</a>}
            content={
              <>
                <NavLink
                  className="navbar-item"
                  activeClassName="is-active"
                  to={ROUTES.TEST.ACT_1}
                >
                  Act 1
                </NavLink>
                <NavLink
                  className="navbar-item"
                  activeClassName="is-active"
                  to={ROUTES.TEST.ACT_2}
                >
                  Act 2
                </NavLink>
                <NavLink
                  className="navbar-item"
                  activeClassName="is-active"
                  to={ROUTES.TEST.ACT_3}
                >
                  Act 3
                </NavLink>
                <NavLink
                  className="navbar-item"
                  activeClassName="is-active"
                  to={ROUTES.GAME.ACT_4}
                >
                  Act 4
                </NavLink>
              </>
            }
          />
        </div>
      </div>
    </Navbar>
  );
}
